function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import _ChevronDownIcon from "@adsk/alloy-react-icon/es/lib/ChevronDownIcon";
var _excluded = ["style", "onExpand", "isExpanded"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { BasicButton } from '@adsk/alloy-react-button';
import { stylePropType } from '@adsk/alloy-react-theme';
var ExpandButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var style = _ref.style,
    onExpand = _ref.onExpand,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleExpand = useCallback(function (e) {
    e.stopPropagation();
    onExpand({
      isExpanded: !isExpanded
    });
  }, [onExpand, isExpanded]);
  return /*#__PURE__*/React.createElement(BasicButton, _extends({
    ref: ref,
    "data-testid": "ExpandIcon",
    "aria-label": 'expand',
    tabIndex: -1,
    style: _objectSpread(_objectSpread({
      color: 'inherit'
    }, style), {}, {
      padding: 0
    }),
    onClick: handleExpand,
    onBlur: function onBlur(e) {
      // Don't trigger parent's onBlur or we'll unhighlight the node
      e.stopPropagation();
    }
  }, props), /*#__PURE__*/React.createElement(_ChevronDownIcon, {
    style: {
      display: 'block',
      transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
      transition: 'transform 0.15s linear'
    }
  }));
});
ExpandButton.displayName = 'ExpandButton';
ExpandButton.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Expansion state */
  isExpanded: PropTypes.bool,
  /** Callback fired on click */
  onExpand: PropTypes.func.isRequired
};
export default ExpandButton;
//# sourceMappingURL=ExpandButton.js.map